import {
  STANDARD_PROPS,
  NAME_TO_ID,
  SPORTRADAR_PROPS_MAPPING,
  TEAM_PROPS,
  EXCLUDED_LIST,
  SPORTRADAR_MATCH_MAPPING,
} from './sportradarMapping.const';

import { SportradarPropsType } from './sportradar.types';

const generateId = () => Math.random().toString(36).slice(2, 9);

export const buildSportradarProps = (config: Record<string, any>[], data: SportradarPropsType, index: number) => Object.keys(data)
  .map(key => {
    if (EXCLUDED_LIST.includes(key)) return '';
    if (typeof config[index][key] === 'string') return `${key}: "${config[index][key]}"`;
    return `${key}: ${config[index][key]}`;
  })
  .filter(Boolean)
  .join(', ');

export const buildSportradar = (
  attr: Record<string, any>,
  sportradarProps: Record<string, any>,
) => {
  const data: Record<string, any> = { ...attr, ...STANDARD_PROPS };
  return Object.keys(data).reduce((acc: Record<string, any>, cur) => {
    if (cur === 'teamTitle') {
      data.title = `${sportradarProps.team ? sportradarProps.team : ''} ${data.title}`;
    } else {
      if (typeof data[cur] === 'undefined') {
        if (TEAM_PROPS.includes(cur)) {
          acc[cur] = sportradarProps.teamUid;
        } else {
          acc[cur] = sportradarProps[cur];
        }
      }

      if (typeof data[cur] !== 'undefined') {
        acc[cur] = sportradarProps[cur] || data[cur];
      }
    }

    return acc;
  }, {});
};

export const buildSportradarList = (
  category: string,
  pageStatus: string,
  tab: string,
  sportradarProps: SportradarPropsType,
) => {
  const widgets = SPORTRADAR_MATCH_MAPPING[category][pageStatus][tab];
  const { teamAId, teamA, teamBId, teamB, seasonId, matchId } = sportradarProps || {};
  let data: Record<string, any> = { seasonId, matchId };

  return widgets.map((widget: string, index: number) => {
    const widgetId = NAME_TO_ID[widget];
    const dataId = `${widgetId}-${matchId || index}-${generateId()}`;

    if (widgets.indexOf(widget) === index) {
      data = { ...data, teamUid: teamAId, team: teamA };
    } else {
      data = { ...data, teamUid: teamBId, team: teamB };
    }

    return buildSportradar(SPORTRADAR_PROPS_MAPPING[widgetId], {
      ...data,
      widgetId: widget,
      dataId,
    });
  });
};

export const buildSportradarFromName = (name: string, sportradarProps: SportradarPropsType) => {
  const id = NAME_TO_ID[name];
  const dataId = `${id}-${generateId()}`;
  const data = {
    ...sportradarProps,
    widgetId: name,
    dataId,
  };

  return [buildSportradar(SPORTRADAR_PROPS_MAPPING[id], data)];
};
